import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { SessionProvider } from "./lib/session";
import useUser from "./hooks/useUser";
import { useMutation } from "@tanstack/react-query";

function App() {
  const [user, setUser] = useState(null);         // admin
  const [endUser, setEndUser] = useState(null);   // member
  // Member and admin pages wait for a saved login to be checked, so a reload stays on the same page.
  const [checkingMember, setCheckingMember] = useState(() => !!localStorage.getItem("user-token"));
  const [checkingAdmin, setCheckingAdmin] = useState(() => !!localStorage.getItem("blood-token"));

  const { tokenvalidate, validateUserToken } = useUser();

  const { mutate: validationToken } = useMutation({
    mutationFn: tokenvalidate,
    onSuccess: (res) => {
      localStorage.setItem("blood-token", res.token);
      setUser(res);
    },
    onError: () => {
      localStorage.removeItem("blood-token");
    },
    onSettled: () => setCheckingAdmin(false),
  });

  const { mutate: validationUserToken } = useMutation({
    mutationFn: validateUserToken,
    onSuccess: (res) => {
      localStorage.setItem("user-token", res.token);
      setEndUser(res);
    },
    onError: () => {
      localStorage.removeItem("user-token");
    },
    onSettled: () => setCheckingMember(false),
  });

  useEffect(() => {
    const adminToken = localStorage.getItem("blood-token");
    if (adminToken) validationToken({ token: adminToken });

    const userToken = localStorage.getItem("user-token");
    if (userToken) validationUserToken({ token: userToken });
  }, [validationToken, validationUserToken]); // eslint-disable-line react-hooks/exhaustive-deps

  if (checkingMember || checkingAdmin) {
    return (
      <div className="app-splash" role="status" aria-label="Loading">
        <span className="app-splash__mark">0709</span>
        <span className="app-splash__name">Bangladesh</span>
      </div>
    );
  }

  return (
    <Router>
      <SessionProvider endUser={endUser} setEndUser={setEndUser}>
        <AppRoutes user={user} setUser={setUser} endUser={endUser} />
      </SessionProvider>
    </Router>
  );
}

export default App;
